module.exports = __webpack_public_path__ + "static/media/chalkboard-teacher.d9fe6cba.svg";